import React, { ComponentProps } from 'react';
import { styled } from '@mui/system';

const Svg = styled('svg')({});

export const PatternLight = (props: ComponentProps<typeof Svg>) => {
  return (
    <Svg
      width="169"
      height="200"
      viewBox="0 0 169 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.15" clipPath="url(#clip0_247_1329)">
        <path
          opacity="0.45"
          d="M15.2754 156.917L15.2754 142.651L30.5348 142.651L30.5348 156.917L15.2754 156.917Z"
          fill="white"
        />
        <path
          opacity="0.45"
          d="M15.2754 171.183L15.2754 156.916L30.5348 156.916L30.5348 171.183L15.2754 171.183Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M30.5312 85.5945L30.5312 71.3281L45.7906 71.3281L45.7906 85.5945L30.5312 85.5945Z"
          fill="white"
        />
        <path
          opacity="0.45"
          d="M30.5312 142.652L30.5312 128.385L45.7906 128.385L45.7906 142.652L30.5312 142.652Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M45.79 99.8557L45.79 85.5894L61.0494 85.5894L61.0494 99.8557L45.79 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M45.79 128.386L45.79 114.12L61.0494 114.12L61.0494 128.386L45.79 128.386Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M45.79 156.917L45.79 142.651L61.0494 142.651L61.0494 156.917L45.79 156.917Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M61.0459 99.8557L61.0459 85.5894L76.3053 85.5894L76.3053 99.8557L61.0459 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M61.0459 114.125L61.0459 99.8589L76.3053 99.8589L76.3053 114.125L61.0459 114.125Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M61.0459 128.386L61.0459 114.12L76.3053 114.12L76.3053 128.386L61.0459 128.386Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M61.0459 171.183L61.0459 156.916L76.3053 156.916L76.3053 171.183L61.0459 171.183Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M45.8232 185.378L45.8232 171.112L61.0826 171.112L61.0826 185.378L45.8232 185.378Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M45.8232 199.606L45.8232 185.34L61.0826 185.34L61.0826 199.606L45.8232 199.606Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M30.6045 199.606L30.6045 185.34L45.8638 185.34L45.8638 199.606L30.6045 199.606Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M0.166992 185.481L0.166992 171.214L15.4263 171.214L15.4263 185.481L0.166992 185.481Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M76.3047 71.3291L76.3047 57.0627L91.5641 57.0627L91.5641 71.3291L76.3047 71.3291Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M76.3047 99.8557L76.3047 85.5894L91.5641 85.5894L91.5641 99.8557L76.3047 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M76.3047 114.125L76.3047 99.8589L91.5641 99.8589L91.5641 114.125L76.3047 114.125Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M76.3047 142.652L76.3047 128.385L91.5641 128.385L91.5641 142.652L76.3047 142.652Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M76.3047 185.448L76.3047 171.182L91.5641 171.182L91.5641 185.448L76.3047 185.448Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M76.3047 199.709L76.3047 185.443L91.5641 185.443L91.5641 199.709L76.3047 199.709Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M91.5605 71.3291L91.5605 57.0627L106.82 57.0627L106.82 71.3291L91.5605 71.3291Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M91.5605 85.5945L91.5605 71.3281L106.82 71.3281L106.82 85.5945L91.5605 85.5945Z"
          fill="white"
        />
        <path
          d="M91.5605 99.8557L91.5605 85.5894L106.82 85.5894L106.82 99.8557L91.5605 99.8557Z"
          fill="white"
        />
        <path
          d="M91.5605 114.125L91.5605 99.8589L106.82 99.8589L106.82 114.125L91.5605 114.125Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M91.5605 128.386L91.5605 114.12L106.82 114.12L106.82 128.386L91.5605 128.386Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M91.5605 156.917L91.5605 142.651L106.82 142.651L106.82 156.917L91.5605 156.917Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M91.5605 185.448L91.5605 171.182L106.82 171.182L106.82 185.448L91.5605 185.448Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M91.5605 199.709L91.5605 185.443L106.82 185.443L106.82 199.709L91.5605 199.709Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M106.819 57.0638L106.819 42.7974L122.079 42.7974L122.079 57.0638L106.819 57.0638Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M106.819 85.5945L106.819 71.3281L122.079 71.3281L122.079 85.5945L106.819 85.5945Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M106.82 99.8557L106.82 85.5894L122.08 85.5894L122.08 99.8557L106.82 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M106.82 114.125L106.82 99.8589L122.08 99.8589L122.08 114.125L106.82 114.125Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M106.82 128.386L106.82 114.12L122.08 114.12L122.08 128.386L106.82 128.386Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M106.82 156.917L106.82 142.651L122.08 142.651L122.08 156.917L106.82 156.917Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M106.82 171.183L106.82 156.916L122.08 156.916L122.08 171.183L106.82 171.183Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M106.82 185.448L106.82 171.182L122.08 171.182L122.08 185.448L106.82 185.448Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M106.82 199.709L106.82 185.443L122.08 185.443L122.08 199.709L106.82 199.709Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M122.079 85.5945L122.079 71.3281L137.338 71.3281L137.338 85.5945L122.079 85.5945Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M122.079 99.8557L122.079 85.5894L137.338 85.5894L137.338 99.8557L122.079 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M122.079 114.125L122.079 99.8589L137.338 99.8589L137.338 114.125L122.079 114.125Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M122.079 142.652L122.079 128.385L137.338 128.385L137.338 142.652L122.079 142.652Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M122.079 156.917L122.079 142.651L137.338 142.651L137.338 156.917L122.079 156.917Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M122.079 171.183L122.079 156.916L137.338 156.916L137.338 171.183L122.079 171.183Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M122.079 185.448L122.079 171.182L137.338 171.182L137.338 185.448L122.079 185.448Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M122.079 199.709L122.079 185.443L137.338 185.443L137.338 199.709L122.079 199.709Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M137.334 14.2718L137.334 0.00537109L152.593 0.00537109L152.593 14.2718L137.334 14.2718Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M137.334 42.7984L137.334 28.532L152.593 28.532L152.593 42.7984L137.334 42.7984Z"
          fill="white"
        />
        <path
          d="M137.334 57.0638L137.334 42.7974L152.593 42.7974L152.593 57.0638L137.334 57.0638Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M137.334 71.3291L137.334 57.0627L152.593 57.0627L152.593 71.3291L137.334 71.3291Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M137.334 85.5945L137.334 71.3281L152.593 71.3281L152.593 85.5945L137.334 85.5945Z"
          fill="white"
        />
        <path
          d="M137.334 99.8557L137.334 85.5894L152.593 85.5894L152.593 99.8557L137.334 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M137.334 156.917L137.334 142.651L152.593 142.651L152.593 156.917L137.334 156.917Z"
          fill="white"
        />
        <path
          opacity="0.85"
          d="M137.334 185.448L137.334 171.182L152.593 171.182L152.593 185.448L137.334 185.448Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M137.334 199.709L137.334 185.443L152.593 185.443L152.593 199.709L137.334 199.709Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M152.594 28.533L152.594 14.2666L167.853 14.2666L167.853 28.533L152.594 28.533Z"
          fill="white"
        />
        <path
          d="M152.594 57.0638L152.594 42.7974L167.853 42.7974L167.853 57.0638L152.594 57.0638Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M152.594 71.3291L152.594 57.0627L167.853 57.0627L167.853 71.3291L152.594 71.3291Z"
          fill="white"
        />
        <path
          d="M152.594 85.5945L152.594 71.3281L167.853 71.3281L167.853 85.5945L152.594 85.5945Z"
          fill="white"
        />
        <path
          d="M152.594 114.125L152.594 99.8589L167.853 99.8589L167.853 114.125L152.594 114.125Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M152.594 128.386L152.594 114.12L167.853 114.12L167.853 128.386L152.594 128.386Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M30.5312 171.183L30.5312 156.916L45.7906 156.916L45.7906 171.183L30.5312 171.183Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M45.79 171.183L45.79 156.916L61.0494 156.916L61.0494 171.183L45.79 171.183Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M61.0459 156.917L61.0459 142.651L76.3053 142.651L76.3053 156.917L61.0459 156.917Z"
          fill="white"
        />
        <path
          d="M76.3047 128.386L76.3047 114.12L91.5641 114.12L91.5641 128.386L76.3047 128.386Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M76.3047 156.917L76.3047 142.651L91.5641 142.651L91.5641 156.917L76.3047 156.917Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M76.3047 171.183L76.3047 156.916L91.5641 156.916L91.5641 171.183L76.3047 171.183Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M91.5605 142.652L91.5605 128.385L106.82 128.385L106.82 142.652L91.5605 142.652Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M91.5605 171.183L91.5605 156.916L106.82 156.916L106.82 171.183L91.5605 171.183Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M106.82 142.652L106.82 128.385L122.08 128.385L122.08 142.652L106.82 142.652Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M122.079 128.386L122.079 114.12L137.338 114.12L137.338 128.386L122.079 128.386Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M137.334 114.125L137.334 99.8589L152.593 99.8589L152.593 114.125L137.334 114.125Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M137.334 128.386L137.334 114.12L152.593 114.12L152.593 128.386L137.334 128.386Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M137.334 142.652L137.334 128.385L152.593 128.385L152.593 142.652L137.334 142.652Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M137.334 171.183L137.334 156.916L152.593 156.916L152.593 171.183L137.334 171.183Z"
          fill="white"
        />
        <path
          opacity="0.95"
          d="M152.594 99.8557L152.594 85.5894L167.853 85.5894L167.853 99.8557L152.594 99.8557Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M152.594 142.652L152.594 128.385L167.853 128.385L167.853 142.652L152.594 142.652Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M152.594 156.917L152.594 142.651L167.853 142.651L167.853 156.917L152.594 156.917Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M152.594 171.183L152.594 156.916L167.853 156.916L167.853 171.183L152.594 171.183Z"
          fill="white"
        />
        <path
          opacity="0.65"
          d="M152.594 185.448L152.594 171.182L167.853 171.182L167.853 185.448L152.594 185.448Z"
          fill="white"
        />
        <path
          opacity="0.65"
          d="M152.594 199.709L152.594 185.443L167.853 185.443L167.853 199.709L152.594 199.709Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_247_1329">
          <rect
            width="200"
            height="168.34"
            fill="white"
            transform="matrix(0 -1 1 0 0 200)"
          />
        </clipPath>
      </defs>
    </Svg>
  );
};
